import { render, staticRenderFns } from "./BasketExtraItem.vue?vue&type=template&id=92438cfc"
import script from "./BasketExtraItem.vue?vue&type=script&lang=js"
export * from "./BasketExtraItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports